import { Button, Icon, Tooltip } from "@chakra-ui/react";
import { FiSend } from "react-icons/fi";
import { useGetOrderMediaConfig } from "../../views/PlaceOrderTest/queryHooks";
import { isPartConfirmationEligibleSupplier } from "./utils/partConfirmationEligibility";

export const RequestPartConfirmationButton = ({
  onClick,
  isAmber = false,
  supplierId,
  size = "md",
  isEstimateOrder = false,
}: {
  onClick: (e: React.MouseEvent) => void;
  isAmber?: boolean;
  supplierId?: string;
  size?: "sm" | "md";
  isEstimateOrder?: boolean;
}) => {
  const { data: mobileConfigs } = useGetOrderMediaConfig();
  const isEligible = isPartConfirmationEligibleSupplier(
    supplierId,
    mobileConfigs?.part_confirmation_eligible_supplier_ids,
  );

  if (!isEligible) {
    return null;
  }

  return (
    <Tooltip label="Request part confirmation" hasArrow>
      <Button
        flex={isEstimateOrder ? 1 : undefined}
        size={size}
        fontSize="xs"
        fontWeight="bold"
        height={isAmber ? undefined : "auto"}
        width={isEstimateOrder ? undefined : isAmber ? undefined : "auto"}
        px={2}
        py={1.5}
        borderRadius="md"
        bg={isAmber ? "#fff7ed" : "#eff6ff"}
        color={isAmber ? "#c2410c" : "#4b85f2"}
        border={isAmber ? "1px solid" : "none"}
        borderColor={isAmber ? "#c2410c" : "none"}
        _hover={{ bg: isAmber ? "#ffedd5" : "#d2e4fb" }}
        leftIcon={
          isEstimateOrder ? <Icon as={FiSend} boxSize={4} /> : undefined
        }
        onClick={(e) => {
          e.stopPropagation();
          onClick(e);
        }}
        aria-label="Request part confirmation"
      >
        {isEstimateOrder ? "Request Confirmation" : <Icon as={FiSend} boxSize={4} />}
      </Button>
    </Tooltip>
  );
};
